module.exports = __webpack_public_path__ + "static/media/teacher-spacing.9b4ff946.svg";